<ds-truncatable-part [maxLines]="1" [background]="isCurrent() ? 'primary' : 'default'" [showToggle]="false">
  @let parentTitle = parentTitle$ | async;
  <div [ngClass]="isCurrent() ? 'text-light' : 'text-body'"
       [title]="parentTitle || ('home.breadcrumbs' | translate)"
       [innerHTML]="parentTitle || ('home.breadcrumbs' | translate)"></div>
</ds-truncatable-part>
<ds-truncatable-part [maxLines]="1" [background]="isCurrent() ? 'primary' : 'default'" [showToggle]="false">
  <div class="fw-bold"
    [ngClass]="isCurrent() ? 'text-light' : 'text-primary'"
  [dsMetadata]="dsoTitle"></div>
</ds-truncatable-part>
@if (description) {
  <ds-truncatable-part [maxLines]="1" [background]="isCurrent() ? 'primary' : 'default'" [showToggle]="false">
    <div class="text-secondary"
      [ngClass]="isCurrent() ? 'text-light' : 'text-secondary'"
    [innerHTML]="description"></div>
  </ds-truncatable-part>
}
